import React from 'react';
import { Grid } from '@mui/material';
import DefaultSelectClient from '../../../components/default-select-client';
import PageHeader from '../../../components/page-header';
import { FilterPanel } from '../../../components/filter-panel';
import { FilterInput, FilterSelect } from '../../../components/filter-fields';
import { GridPanel } from '../../../components/list-grid-panel';
import ContractDataTable from './components/contract-data-table';
import { useContractSearchController } from './context/contract-search-controller';
import { useContractSearchState } from './context/contract-search-context';
import { toLookupOptions } from '../shared/lookup-select';
import { buildSortOptions, toSortValue } from '../shared/scp-utils';
import { ContractSortField } from '../../../model/scp/contract/contract-sort-field';

const CONTRACT_SORT_OPTIONS = buildSortOptions([
    { field: ContractSortField.UpdatedDate, label: 'Data de Alteração' },
    { field: ContractSortField.CreatedDate, label: 'Data de Criação' },
    { field: ContractSortField.ContractEffortNumber, label: 'Nº Empenho' },
    { field: ContractSortField.NumberProcess, label: 'Nº Processo' },
    { field: ContractSortField.Year, label: 'Exercício' },
    { field: ContractSortField.SupplierName, label: 'Fornecedor' },
    { field: ContractSortField.ContractType, label: 'Tipo de Contrato' },
    { field: ContractSortField.ProcessCategory, label: 'Categoria de Processo' },
]);

export function ContractSearchComponent() {
    const ctrl = useContractSearchController();
    const { typeContract, categoryProcess, parameters, searchTrigger } = useContractSearchState();

    return (
        <React.Fragment>
            <Grid item xs={12}>
                <PageHeader
                    title="Contratos"
                    subtitle="Pesquise e gerencie os contratos publicados"
                    breadcrumbs={[{ label: 'Contratos' }]}
                />
            </Grid>

            <Grid item xs={12}>
                <FilterPanel onClear={ctrl.handleClearFilters} onSearch={ctrl.handleSearch}>
                    <Grid item xs={12} md={6}>
                        <FilterInput label="Buscar por" name="input-term" value={parameters.term} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <FilterSelect label="Ordenar por" name="select-sort" value={toSortValue(parameters.sortBy, parameters.sortDirection)} options={CONTRACT_SORT_OPTIONS} onChange={ctrl.handleOnChange} emptyLabel="Padrão" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={3}>
                        <FilterInput label="Exercício" name="input-year" type="number" value={parameters.year} onChange={ctrl.handleOnChange} onSearch={ctrl.handleSearch} />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FilterSelect label="Tipo de Contrato" name="select-contract-type" value={parameters.contractTypeId} options={toLookupOptions(typeContract)} onChange={ctrl.handleOnChange} emptyLabel="Todos" />
                    </Grid>
                    <Grid item xs={12} sm={6} md={4}>
                        <FilterSelect label="Categoria do Processo" name="select-category-process" value={parameters.categoryProcessId} options={toLookupOptions(categoryProcess)} onChange={ctrl.handleOnChange} emptyLabel="Todas" />
                    </Grid>
                    <Grid item xs={12} md={4}>
                        <DefaultSelectClient required={false} clientId={parameters.clientId} handleOnChange={ctrl.handleOnChange} />
                    </Grid>
                </FilterPanel>
            </Grid>

            <Grid item xs={12}>
                <GridPanel addLabel="Novo contrato" onAdd={ctrl.navigateToCreate}>
                    <ContractDataTable
                        parameters={parameters}
                        searchTrigger={searchTrigger}
                        onPaginationChange={ctrl.handlePaginationChange}
                        onEdit={ctrl.navigateToEdit}
                        onAmendments={ctrl.navigateToAmendments}
                        onDelete={ctrl.handleDelete}
                    />
                </GridPanel>
            </Grid>
        </React.Fragment>
    );
}
